'use client'

import { captureDeferredSentryException } from '@/utils/deferredSentry'
import Error from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({ error }) {
  useEffect(() => {
    captureDeferredSentryException(error)
  }, [error])

  return (
    // eslint-disable-next-line jsx-a11y/html-has-lang
    <html>
      <body>
        <Error />
      </body>
    </html>
  )
}
